import _ from 'underscore';

const addSelected = (entity, prop, selected) => {
	let selectedProp = {};

	if(selected !== undefined && selected !== null) {
		if(selected.length !== undefined) {
			selectedProp[prop] = _.contains(selected, entity.id.toString());
		}
		else if(typeof selected === 'boolean') {
			selectedProp[prop] = selected;
		}
		else if(typeof selected === 'object') {
			selectedProp[prop] = entity === selected;
		}
		else {
			selectedProp[prop] = entity.id === selected;
		}
	}

	return selectedProp;
};

export default addSelected;


/** WEBPACK FOOTER **
 ** ./src/js/selectors/selected_selector.js
 **/